import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
// import { Tooltip } from '@mui/material';

//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import TablePagination from '@mui/material/TablePagination';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

//import '../../styles.css';
function EventIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteEvent, setDeleteEvent] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    //const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history

    const { isAuthenticated, branchId, clubId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
        //inputRef.current.focus();
    }, [isAuthenticated, clubId, branchId, token, logout]);

    // useEffect(() => {
    //     if (searchTerm.trim() == '') {
    //         setFilteredData(data);
    //     } else {
    //         const filtered = data.filter(event1 => event1.event.toLowerCase().includes(searchTerm.toLowerCase()));
    //         setFilteredData(filtered);
    //     }
    // }, [data, searchTerm]);
    useEffect(() => {

        fetchtableData();

    }, []);
    const fetchtableData = async () => {
        fetchData('EventApi', `/${branchId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Income Details:', error);
            });


    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const handleDelete = async () => {
        deleteData('EventApi', `${deleteEvent}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteEvent(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };


    const handleActivate = (id) => {
        activateData('EventApi', `${id}`)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (id) => {
        setDeleteEvent(id);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteEvent(null);
        setConfirmDialogOpen(false);
    };
    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page when changing rows per page
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>

                {/* <h6 className='productHead flex-grow linkcolor'
                    style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    EVENTS</h6>


                <div className="button-container-1">

                    <Button
                        component={Link}
                        to="/EventCreate"
                        className="linkcolor"
                        style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#347928', height: '25px' }}
                    >
                        <AddIcon /> CREATE
                    </Button>
                </div> */}

                <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}> EVENTS</h6>
               
                <input
                    className="shadow text-gray-700 leading-tight"
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? '250px' : '140px',
                        height: '30px',
                        border: '1px solid #ccc',
                        borderRadius: '15px',
                        padding: '0 20px',
                        transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                        outline: 'none',
                        borderColor: isFocused ? 'darkcyan' : '#ccc',
                        boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        marginLeft: '10px'
                    }}
                />

                <div className="button-container-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Tooltip
                        title="Create EVENTS"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#0e728c',
                                    color: 'white',
                                    border: '1px solid white',
                                    fontWeight: 'bold',
                                    boxShadow: 2,
                                },
                            },
                        }}
                    >
                        <Button
                            component={Link}
                            to="/EventCreate"
                            className="linkcolor"
                            style={{ color: 'whitesmoke', fontsize:'11px',  backgroundColor: '#27391C', height: '25px' ,marginLeft:'5px' }}
                            >
                            CREATE
                        </Button>
                    </Tooltip>
                </div>

            </div>

           {/* <div className='w-full mb-2 flex'>
                <input
                    ref={inputRef}//mouse pointer focus to textfield
                    type="text"
                    placeholder="Search by Event name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                />
            </div>*/}

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader> 
                        <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Event</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Venue</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#15abd2', borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#cef1fa' }}>

                            {paginatedData.map((event, index) => (
                                <TableRow
                                    key={event.id}
                                    className={event.isActive ? '' : 'inactiveRow'}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd',// Alternate row background colors
                                    }}
                                >

                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>{event.event}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>{event.venue}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>{formatDateForInput(event.fromDate)}</TableCell>

                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '2px' }}>
                                        <Link to={`/EventEdit/${event.id}`}>
                                        <Tooltip title="Edit Events">
                                            <IconButton>
                                                <EditIcon style={{ fontsize: '5px', color: 'blue' }} />
                                            </IconButton>
                                            </Tooltip>
                                        </Link>
                                        <Tooltip title="Delete Events">
                                            <IconButton onClick={() => (event.isActive ? openConfirmDialog(event.id) : handleActivate(event.id))}>
                                                {event.isActive ? (
                                                    <DeleteIcon style={{ fontsize: '5px', color: 'brown' }} />
                                                ) : (
                                                    <ActivateIcon />
                                                )}
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>


                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>



                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]} 
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            '& .MuiTablePagination-toolbar': {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'nowrap', // Ensures everything stays in one line
                                minHeight: '40px', // Keeps a proper height
                            },
                            '& .MuiTablePagination-selectLabel': {
                                marginBottom: 0, // Fixes label misalignment
                            },
                            '& .MuiTablePagination-displayedRows': {
                                marginBottom: 0, // Fixes row count misalignment
                            },
                        }}
                    />

                </TableContainer>
            </div>
        </div>
    );
}

export default EventIndex;




